<template>
  <div>
    <search-agent-cpe @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findAgentCpes } from '@/api/agent'
import Pagination from '@/components/Pagination'
import SearchAgentCpe from '@/views/cpes/agent/Search'

export default {
  name: 'AgentCpeList',
  components: {
    Pagination,
    SearchAgentCpe
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      columns: [
        {
          title: 'SN',
          dataIndex: 'sn',
          width: 160,
          fixed: 'left'
        },
        {
          title: 'IMEI1',
          dataIndex: 'imei1',
          width: 160
        },
        {
          title: 'IMEI2',
          dataIndex: 'imei2',
          width: 160
        },
        {
          title: 'CPE型号',
          dataIndex: 'cpe_model_name',
          width: 140
        },
        {
          title: '通信制式',
          dataIndex: 'comm_mode_name',
          width: 120
        },
        {
          title: '固件版本',
          dataIndex: 'firmware_version',
          width: 120
        },
        {
          title: '订单编号',
          dataIndex: 'order_no',
          width: 220,
          ellipsis: true
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        }
      ]
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    }
  },
  watch: {
    agentId() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentCpes(this.agentId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
